import React, { FC } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import useClassNames from 'helpers/hooks/useClassNames';
import { MenuItem } from '../../../types';

export interface Props {
  show: boolean;
  link: MenuItem;
  iconDirection?: 'up' | 'down';
}

const HeaderNavigationButtonDesktop: FC<Props> = ({ show, link, iconDirection }) => {
  const navLinkClassNames = useClassNames([
    'flex border-primary cursor-pointer relative hover:border-b-2 py-4',
    show ? 'border-b-2' : '',
  ]);

  return (
    <Link link={link?.link} title={link?.name} className={navLinkClassNames}>
      <Typography className="body-text" as="span">
        {link?.name}
      </Typography>
      {link?.descendants &&
        link?.descendants.length > 0 &&
        (iconDirection === 'up' ? (
          <ChevronUpIcon className="ml-8 w-16 text-icon-secondary transition-transform duration-200" />
        ) : (
          <ChevronDownIcon className="ml-8 w-16 text-icon-secondary transition-transform duration-200" />
        ))}
    </Link>
  );
};
export default HeaderNavigationButtonDesktop;
